import { render } from "./terms-of-service.vue?vue&type=template&id=43c4e510"
import script from "./terms-of-service.vue?vue&type=script&lang=js"
export * from "./terms-of-service.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__